export default "__VITE_ASSET__Huh8qdg0__"